<template>
  <Modal @close="$emit('close')" v-if="challenge">
    <div slot="body">
      <div class="row">
        <div class="col-lg-6 text-center">
          <!-- <div class="row">
            <div class="col-12 h1 text-primary">
              <i class="fas fa-dna"></i>
            </div>
          </div> -->
          <div class="row">
            <div class="col-12 text-darker">
              <span class="h1">Desafío {{ challenge.id }}</span>
            </div>
          </div>
          <div class="row text-primary">
            <div class="col-12 h5 mb-2">
              {{ challenge.mdTemas.map(i => i.nombre).join(", ") }}
            </div>
          </div>
          <div class="row text-gray">
            <div
              class="col-12 text-justify"
              v-for="texto in challenge.mdTextosdecontrols"
              :key="texto.id"
            >
              {{ texto.contenido }}
              <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ut
              lorem scelerisque, tristique nunc id, viverra tortor. Duis
              imperdiet porttitor nunc lacinia porttitor. Donec interdum lacinia
              quam vitae feugiat. Nulla est est, lacinia vitae quam sed, posuere
              porttitor nisl. Morbi malesuada tincidunt justo id accumsan. Nam
              dictum justo at tincidunt porta. -->
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <template>
            <QuestionAccordion
              v-for="pregunta in challenge.mdTestPreguntases"
              :key="pregunta.id + '' + pregunta.showDetail"
              :data="pregunta"
              @setAccordion="setAccordion"
            />
          </template>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-9">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <button class="button secondary px-5" @click="$emit('close')">
                Volver
              </button>
            </div>
            <div class="col-12 col-md-6 col-lg-8">
              <!-- <button class="button default text-blue px-5">
                Añadir a favoritos
                <div class="icon">
                  <i class="fas fa-heart text-gray"></i>
                </div>
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import QuestionAccordion from "@/components/challenge/QuestionAccordion";

export default {
  name: "ModalChallenge",
  components: {
    Modal,
    QuestionAccordion,
  },
  props: ["challengeData"],
  data() {
    return {
      challenge: null,
    };
  },
  methods: {
    setAccordion(id = null) {
      for (let pregunta in this.challenge.mdTestPreguntases) {
        if (id != this.challenge.mdTestPreguntases[pregunta].id) {
          this.challenge.mdTestPreguntases[pregunta].showDetail = false;
        } else {
          this.challenge.mdTestPreguntases[pregunta].showDetail = true;
        }
      }
      let challenge = this.challenge;
      this.challenge = [];
      this.challenge = challenge;
    },
  },
  mounted() {
    this.challenge = this.challengeData;
    this.setAccordion();
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.icon {
  position: absolute;
  right: -20px;
  top: -10px;
  width: 55px;
  height: 55px;
  background: white;
  box-shadow: 0px 1px 14px -3px rgba(64, 64, 64, 0.4);
  border-radius: 50%;
  text-align: center;

  i {
    font-size: 34px;
    padding-top: 12px;
  }
}
</style>
